import { render } from "./CoverPage.vue?vue&type=template&id=2996b526&scoped=true&ts=true"
import script from "./CoverPage.vue?vue&type=script&lang=ts"
export * from "./CoverPage.vue?vue&type=script&lang=ts"

import "./CoverPage.vue?vue&type=style&index=0&id=2996b526&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2996b526"]])

export default __exports__